// https://support.axeptio.eu/fr/articles/274012-gerer-les-services-qui-affichent-du-contenu-sur-votre-site-youtube-maps-chat

window._axcb = window._axcb || [];
window._axcb.push(function (sdk) {

  // When the user has finished making their cookie choices
  sdk.on('cookies:complete', function(choices){

    // 1. Hide messages/buttons if the service has been accepted
    document
      .querySelectorAll('[data-hide-on-vendor-consent]')
      .forEach(el => {
        const vendor = el.getAttribute('data-hide-on-vendor-consent');
        el.style.display = choices[vendor] ? 'none' : 'inherit';
      });

    // 2. Load content (iframes) only if the service is accepted
    document
      .querySelectorAll('[data-requires-vendor-consent]')
      .forEach(el => {
        const vendor = el.getAttribute('data-requires-vendor-consent');
        if (choices[vendor]) {
          // Replace data-src with src to trigger loading
          el.setAttribute('src', el.getAttribute('data-src'));
        }
      });
  });
});